import { UpgradeWorkflow } from '../../types/workflows/UpgradeWorkflow';
import { UpgradeWorkflowAction } from '../../actions/workflows/UpgradeWorkflow';
import initialState from '../../InitialState';
import produce from 'immer';
import { toSafeUIData } from 'vrlcm-gui-utils';

type Action = UpgradeWorkflowAction;
const upgradeWorkflow = (
  state: UpgradeWorkflow = initialState.upgradeWorkflow,
  action: Action
): UpgradeWorkflow => {
  return produce<UpgradeWorkflow, UpgradeWorkflow>(state, draft => {
    switch (action.type) {
      case 'INITIALIZE_UPGRADE_WORKFLOW':
        draft.fetching = true;
        draft.fetchingFailed = false;
        break;
      case 'INITIALIZE_UPGRADE_WORKFLOW_FAILED':
        draft.fetching = false;
        draft.fetchingFailed = true;
        break;
      case 'INITIALIZE_UPGRADE_WORKFLOW_SUCCESS':
        draft.fetching = false;
        draft.existingVidm = action.payload.existingVidm;
        draft.state = action.payload.state;
        break;
      case 'UPDATE_UPGRADE_STEP_STATES':
        const uiData = toSafeUIData(state.state.uiData);
        uiData.stepStates = action.payload.stepStates;
        draft.state.uiData = JSON.stringify(uiData);
        break;
      case 'SAVE_UPGRADE_WORKFLOW':
      case 'SUBMIT_UPGRADE_WORKFLOW':
        draft.submitStatus = { submitting: true, failed: false };
        break;
      case 'SAVE_UPGRADE_WORKFLOW_FAILED':
      case 'SUBMIT_UPGRADE_WORKFLOW_FAILED':
        draft.submitStatus = { submitting: false, failed: true };
        break;
      case 'SAVE_UPGRADE_WORKFLOW_SUCCESS':
        draft.submitStatus.submitting = false;
        draft.state = action.payload.state;
        break;
      case 'SUBMIT_UPGRADE_WORKFLOW_SUCCESS':
        draft.submitStatus = { submitting: false, failed: false };
        break;
    }
  });
};

export default upgradeWorkflow;
